import { Toast } from "flowbite-react";
import { HiCheck } from "react-icons/hi";

interface CheckEmailToastProps {
  message?: string;
}

function CheckEmailToast({ message= "T'as reçu un lien d'activation de compte sur ta boîte mail !" }: CheckEmailToastProps) {

  return (
    <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50 flex flex-col gap-4">
      <Toast>
        <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500 dark:bg-green-800 dark:text-green-200">
          <HiCheck className="h-5 w-5" />
        </div>
        <div className="ml-3 text-sm font-normal">{message}</div>
      </Toast>
    </div>
  );
}

export default CheckEmailToast;